import { Globe2, Headset, IndianRupee, MapPinHouse, PackageCheck, Radar } from "lucide-react";

const PILLARS = [
  { icon: Globe2, text: "International Delivery · 220+ Countries" },
  { icon: MapPinHouse, text: "Door-to-Door Doorstep Service" },
  { icon: Radar, text: "Real-Time Scan-Level Tracking" },
  { icon: PackageCheck, text: "Secure Commercial Handling" },
  { icon: Headset, text: "Expert Human Support" },
  { icon: IndianRupee, text: "Competitive Multi-Carrier Rates" },
];

export default function TrustStrip() {
  const row = [...PILLARS, ...PILLARS];
  return (
    <section className="mt-14 overflow-hidden border-y border-slate-200 bg-white py-5" data-testid="trust-strip">
      <div className="flex w-max items-center gap-10 pr-10" style={{ animation: "marquee 32s linear infinite" }}>
        {row.map((p, i) => (
          <span key={i} {...(i < PILLARS.length ? { "data-testid": `trust-pillar-${i}` } : { "aria-hidden": "true" })}
                className="flex shrink-0 items-center gap-2.5 text-sm font-bold text-navy">
            <span className="grid h-8 w-8 place-items-center rounded-full bg-saffron/10 text-saffron">
              <p.icon className="h-4 w-4" />
            </span>
            {p.text}
            <span className="ml-6 h-1.5 w-1.5 rounded-full bg-saffron/40" />
          </span>
        ))}
      </div>
    </section>
  );
}
